import type { BuildingStructuralMaterialsSections } from "../../../types/buildings-sections/structural-materials";

export const structuralMaterials: BuildingStructuralMaterialsSections = {
  title: "Konstruktsioonimaterjalid",
  description: "Konstruktsioonimaterjalide info",
  noDataAvailable: "Konstruktsioonimaterjalide andmed puuduvad",
  material: "Materjal",
  details: "Detailid",
  specifications: "Spetsifikatsioonid",
  manufacturer: "Tootja",
  installationDate: "Paigalduskuupäev",
};
